import { AuthUser } from "aws-amplify/auth";
import L from 'leaflet';
import { PlaceDefinition } from "../../utils/PlaceDataUtils";

export abstract class PlaceMarker extends L.Marker {
    protected placeDefinition: PlaceDefinition;
    protected loggedInUser: AuthUser;
    protected handlePlaceClick: (placeDefinition: PlaceDefinition) => void;

    constructor(
        placeDefinition: PlaceDefinition,
        loggedInUser: AuthUser,
        handlePlaceClick: (placeDefinition: PlaceDefinition) => void
    ) {
        super([placeDefinition.lat, placeDefinition.lng], {
            autoPan: true,
            riseOnHover: true
        });

        this.placeDefinition = placeDefinition;
        this.loggedInUser = loggedInUser;
        this.handlePlaceClick = handlePlaceClick;
    }

    public getPlaceId(): string {
        return this.placeDefinition.placeId;
    }

    public getPlaceDefinition(): PlaceDefinition {
        return this.placeDefinition;
    }

    protected createInvisibleIcon(): L.DivIcon {
        // Create an invisible placeholder icon to prevent flash during image & place marker loading
        return L.divIcon({
            className: 'custom-marker',
            html: '<div style="opacity: 0; width: 0; height: 0;"></div>',
            iconSize: [0, 0],
            iconAnchor: [0, 0],
        });
    }

} 